import React from "react";
import {
  ActivityIndicator,
  Button,
  Text,
  View,
  Image
} from "react-native";

import { useAuthSession } from "./AuthProvider";
import AppTheme from "../../../shared/utils/Theme";

interface AuthStartupGateProps {
  children: React.ReactNode;
}

export function AuthStartupGate(props: AuthStartupGateProps) {

  const session = useAuthSession();

  const { children } = props;

  const appTheme: AppTheme = new AppTheme();

  if (session.status === "initializing") {
    return (
      <View style={[{ width: appTheme.getFullScreenWidth(), height: appTheme.getFullScreenHeight(), backgroundColor: "#FFFFFF", justifyContent: "center", alignItems: "center" }]}>
        <Image
          source={require("../../../shared/assets/img/ic_logo_simple.png")}
          style={{ width: appTheme.pixelPerfect(136), height: appTheme.pixelPerfect(136), opacity: 1 }}
          resizeMode="contain" />
        <View style={{ position: "absolute", bottom: 0, width: "100%", justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator color={appTheme.talk} />
        </View>
      </View>
    );
  }

  if (session.status === "error") {
    return (
      <View>
        <Text>{session.error.message}</Text>
        <Button
          title="Recharger"
          onPress={() => window.location.reload()}
        />
      </View>
    );
  }

  return <>{children}</>;
}